import { TW_TextFilterValueEditor, TW_TextFilterValueEditor_editing, TW_TextFilterValueEditor_Wrapper } from "@utils/twClasses";
import { displayText } from "@utils/types";
import { useEffect, useState } from "react";
import { AbstractValueEditor } from "./AbstractValueEditor";
import { cn } from "@comps/lib/utils";

type TextValueEditorProps = {
    format: Map<string, any> | undefined;
    value: any;
    disabled: boolean;
    onValueChange: (value: any) => void;
    className?: string;
}

export function TextValueEditor({ format, value, disabled, onValueChange, className }: TextValueEditorProps) {


    const [text, setText] = useState(value || "");
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        setText(value || "");
    }, [value]);

    const textToValue = (text: string | null): any => {
        return displayText(text, format);
    }

    function isTextValid(value: string | null) {
        return true;
    }

    const renderReadOnlyContent = () => {
        return (
            <div className={cn(TW_TextFilterValueEditor_Wrapper, className)} onClick={() => setEditing(true)}>
                <div className={TW_TextFilterValueEditor}>
                    {(value !== undefined) ? value : ""}
                </div>
            </div>)
    }

    const renderEditingContent = (
        onBlur: () => void,
        onEnterKeyPress: (event: React.KeyboardEvent) => void,
        onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        getText: () => string | null) => {
        return (<div tabIndex={0} className={cn(TW_TextFilterValueEditor_Wrapper, className)} onKeyDown={onEnterKeyPress}>
            <input
                className={TW_TextFilterValueEditor_editing}
                type="text"
                value={text}
                onBlur={onBlur}
                onChange={onTextChange}
                autoFocus={true}
                disabled={disabled} />
        </div>)
    }

    return <AbstractValueEditor
        initialValue={value}
        editing={editing}
        renderReadOnlyContent={renderReadOnlyContent}
        renderEditingContent={renderEditingContent}
        textToValue={textToValue}
        isTextValid={isTextValid}
        getText={() => text}
        setText={setText}
        setEditing={setEditing}
        onValueChange={onValueChange} />
}
